<div class="col-lg-12 col-md-12 col-sm-12">
    <div  class="table-responsive">
        <table  class="table table-sm table-bordered text-center">
            <thead>
                <tr class="bg-primary text-white p-0">
                    <th>Date</th>
                    <th>Service Name</th>
                    <th>Video Link</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor = "let videolist of this.videoList">
                    <td>
                        {{videolist.date}}
                    </td>
                    <td>
                        {{videolist.service_name}}
                    </td>
                    <td>
                       <a [href]="videolist?.recording_link" target="_blank">View Recording</a>
                        <!-- <iframe src="videolist.recording_link" title="Video Recording">
                        </iframe> -->
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</div>

